import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

import { DialogProps } from "@toolpad/core/useDialogs";

import { DialogoBaseProps } from "@interfaces/components";
import { AssignableOwner } from "@hooks/useAssignableOwners";
import { OwnerAutocompleteInput } from "@components/OwnerAutocompleteInput";

interface AsignarOwnerEtapaProps extends DialogoBaseProps {
    stageName: string;
    options: Array<AssignableOwner>;
}

export const AsignarOwnerEtapa = (props: DialogProps<AsignarOwnerEtapaProps, AssignableOwner | undefined>) => {
    const [userSelected, setUserSelected] = useState<AssignableOwner | null>(null);

    return (
        <Dialog fullWidth={props.payload.fullWidth ?? true} open={props.open}>
            <DialogTitle>Asignar owner de "{props.payload.stageName}"</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Selecciona a la persona encargada de esta etapa:
                </Typography>
                <OwnerAutocompleteInput
                    loading={false}
                    options={props.payload.options}
                    value={userSelected}
                    onChange={setUserSelected}
                    showEmail
                />
            </DialogContent>
            <DialogActions sx={{ mb: 2, justifyContent: "space-evenly" }}>
                <Button variant="blue_outlined" onClick={() => props.onClose(undefined)}>
                    Cerrar
                </Button>
                <Button variant="contained" disabled={!userSelected} onClick={() => props.onClose(userSelected ?? undefined)}>
                    Asignar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
